// Historique des fonctionnalités livrées et en cours.
// Ajoutez une nouvelle entrée en haut du tableau à chaque évolution notable.
const patchNotes = [
    {
        date: '2026-08-09',
        status: 'done',
        title: 'Exceptions de récurrences',
        description: 'Supprimer une livraison récurrente crée désormais une exception : la livraison ne sera pas recréée par le cron, sans toucher aux autres occurrences de la récurrence.',
    },
    {
        date: '2026-08-09',
        status: 'done',
        title: 'Correction de l\'affichage des hauts faits',
        description: 'Les hauts faits débloqués s\'affichaient parfois comme verrouillés à cause d\'une limite de pagination. Tous les hauts faits sont désormais correctement chargés.',
    },
    {
        date: '2026-08-09',
        status: 'done',
        title: 'Mise à jour automatique de l\'application',
        description: 'Un bandeau apparaît automatiquement quand une nouvelle version est disponible, sans avoir à faire Ctrl+F5. La mise à jour se fait en un clic.',
    },
    {
        date: '2026-08-09',
        status: 'done',
        title: 'Nettoyage de session à la connexion',
        description: 'Les données de l\'ancienne session sont effacées à chaque nouvelle connexion, évitant les problèmes d\'affichage après expiration du token.',
    },
    {
        date: '2026-07-31',
        status: 'done',
        title: 'Classement et points des hauts faits',
        description: 'Les hauts faits rapportent désormais des points. Un classement général affiche le score de chaque utilisateur, et il est possible de voir les hauts faits débloqués par ses collègues.',
    },
    {
        date: '2026-07-31',
        status: 'done',
        title: 'Correction des doublons de récurrences',
        description: 'Les livraisons récurrentes ne sont plus dupliquées si elles ont été déplacées de date. Un champ "date d\'origine" permet au système de retrouver la livraison existante.',
    },
    {
        date: '2026-07-31',
        status: 'done',
        title: 'Alerte SAP sur une livraison',
        description: 'Les administrateurs peuvent signaler un problème SAP sur une livraison via l\'icône ⚠️ dans la modale. La livraison concernée pulse en rouge pour alerter tous les utilisateurs.',
    },
    {
        date: '2026-07-31',
        status: 'done',
        title: 'Suppression automatique des logs',
        description: 'Les logs de modification et suppression de plus de 3 semaines sont automatiquement effacés chaque nuit. Les logs de création sont conservés indéfiniment.',
    },
    {
        date: '2026-07-31',
        status: 'done',
        title: 'Filtre par livreur attitré dans la page patients',
        description: 'Nouveau filtre dans la liste des patients permettant de filtrer par livreur attitré, avec option pour afficher uniquement les patients sans livreur attitré.',
    },
    {
        date: '2026-07-31',
        status: 'done',
        title: 'Immuno propagé depuis les récurrences',
        description: 'Le champ immunosuppresseur peut désormais être paramétré directement sur une récurrence. Les livraisons générées héritent automatiquement de ce paramètre.',
    },
    {
        date: '2026-07-31',
        status: 'done',
        title: 'Régénération des récurrences améliorée',
        description: 'La régénération manuelle d\'une récurrence met à jour les livraisons futures existantes (livreur, période, immuno) sans supprimer les notes et statuts déjà saisis.',
    },
    {
        date: '2026-07-27',
        status: 'done',
        title: 'Carte interactive des patients',
        description: 'Nouvelle page "Carte patients" avec affichage géographique de tous les patients, filtres par statut, pathologie et livreur, et bascule entre coloration par pathologie ou par secteur géographique.',
    },
    {
        date: '2026-07-27',
        status: 'done',
        title: 'Ville secondaire affichée dans le planning',
        description: 'Quand une adresse secondaire est sélectionnée pour une livraison, la ville secondaire s\'affiche désormais correctement sur la carte de livraison.',
    },
    {
        date: '2026-07-27',
        status: 'done',
        title: 'Changement de livreur depuis la vue mobile',
        description: 'Les livreurs peuvent désormais modifier le livreur attitré d\'une livraison directement depuis la vue mobile.',
    },
    {
        date: '2026-07-27',
        status: 'done',
        title: 'Historique de création dans la fiche livraison',
        description: 'Un footer discret affiche le créateur et la date de création d\'une livraison, ainsi que la récurrence d\'origine si applicable.',
    },
    {
        date: '2026-07-27',
        status: 'done',
        title: 'Auto-statut "Préparé" selon le type de livraison',
        description: 'Les livraisons de type récupération, visite patient ou standard passent automatiquement en statut "Préparé" lors de la sélection du type.',
    },
    {
        date: '2026-07-27',
        status: 'done',
        title: 'Filtrage des patients FTT dans Mon trajet',
        description: 'Les patients en fin de traitement (FTT) sont désormais exclus de la vue "Mon trajet" et ne génèrent plus de livraisons récurrentes.',
    },
    {
        date: '2026-07-19',
        status: 'done',
        title: 'Système de hauts faits',
        description: 'Débloquez des hauts faits en utilisant l\'application : nombre de livraisons, trajets optimisés, ancienneté... Consultez votre progression via le bouton 🏆 dans le menu.',
    },
    {
        date: '2026-07-19',
        status: 'done',
        title: 'Swipe pour changer de jour (mobile)',
        description: 'En vue mobile, glisser le doigt vers la gauche ou la droite change de jour automatiquement.',
    },
    {
        date: '2026-07-19',
        status: 'done',
        title: 'Modification rapide depuis la fiche patient',
        description: 'Cliquer sur une livraison dans l\'historique d\'un patient ouvre directement la modale de modification.',
    },
    {
        date: '2026-07-19',
        status: 'done',
        title: 'Modales retravaillées',
        description: 'Nouvelle mise en page pour la création de patient et de livraison : plus compact, plus lisible, boutons à icônes pour les statuts et types.',
    },
    {
        date: '2026-07-17',
        status: 'done',
        title: 'Adresse de livraison secondaire',
        description: 'Possibilité de choisir l\'adresse principale ou secondaire du patient pour une livraison, avec géolocalisation combinée et prise en compte dans l\'optimisation de tournée.',
    },
    {
        date: '2026-07-17',
        status: 'done',
        title: 'Priorité des rétrocessions',
        description: 'Les patients marqués "rétrocession" apparaissent désormais en rouge, toujours en tête de la tournée du livreur, y compris dans l\'optimisation automatique du trajet.',
    },
    {
        date: '2026-07-15',
        status: 'done',
        title: 'Mode sombre étendu au planning',
        description: 'Le thème sombre s\'applique maintenant à l\'ensemble du planning : en-tête, colonnes des jours et cartes de livraison.',
    },
    {
        date: '2026-07-15',
        status: 'done',
        title: 'Nouveau logo',
        description: 'Un nouveau logo, plus moderne et épuré, mêlant symbolique médicale et logistique.',
    },
    {
        date: '2026-07-15',
        status: 'done',
        title: 'Waze intégré à Mon trajet',
        description: 'En plus de Google Maps, possibilité d\'ouvrir Waze pour naviguer vers une livraison, avec départ automatique depuis la position actuelle.',
    },
    {
        date: '2026-07-14',
        status: 'done',
        title: 'Rôle "Personne sans accès"',
        description: 'Nouveau rôle permettant de référencer une personne dans les listes (secteurs, livreurs) sans lui donner accès à l\'application.',
    },
    {
        date: '2026-07-12',
        status: 'done',
        title: 'Consigne horaire libre',
        description: 'Les créneaux horaires stricts sont remplacés par une consigne horaire en texte libre, plus flexible pour organiser les tournées.',
    },
    {
        date: '2026-07-12',
        status: 'done',
        title: 'Menu Statistiques',
        description: 'Nouveau tableau de bord avec graphiques : volume de livraisons, répartition par livreur/type/statut/secteur/pathologie, sur une période personnalisable.',
    },
    {
        date: '2026-07-12',
        status: 'done', // 'done' | 'in_progress'
        title: 'Suppression des horaires stricts',
        description: 'Les livraisons utilisent désormais matin/après-midi + une consigne horaire texte libre, plus flexible qu\'un créneau strict.',
    },
    {
        date: '2026-07-12',
        status: 'done',
        title: 'Bouton Waze',
        description: 'En plus de Google Maps, possibilité d\'ouvrir Waze pour la première destination de la tournée.',
    },
    {
        date: '2026-07-11',
        status: 'done',
        title: 'Fiche patient dédiée',
        description: 'La fiche patient s\'ouvre désormais en page complète (adresse principale/secondaire, historique livraisons scrollable) au lieu d\'une modale.',
    },
    {
        date: '2026-07-11',
        status: 'done',
        title: 'Optimisation de tournée (ORS)',
        description: 'Calcul automatique de l\'ordre de passage optimal via OpenRouteService, avec distance et temps de trajet estimés.',
    },
    {
        date: '2026-07-10',
        status: 'in_progress',
        title: 'Gestion des livraisons rétrocession CHU',
        description: 'Les livraisons rétro (Brabois, Épinal...) auront bientôt leur propre logique d\'affichage, prioritaire en début de tournée.',
    },
    {
        date: '2026-07-10',
        status: 'in_progress',
        title: 'Menu Statistiques',
        description: 'Un espace dédié aux statistiques pour les administrateurs est en préparation.',
    },
];

export default patchNotes;